export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_USER_LIST_REQUEST = "ORDER_USER_LIST_REQUEST";
export const ORDER_USER_LIST_SUCCESS = "ORDER_USER_LIST_SUCCESS";
export const ORDER_USER_LIST_FAIL = "ORDER_USER_LIST_FAIL";
export const ORDER_USER_LIST_RESET = "ORDER_USER_LIST_RESET";

export const ORDER_ADMIN_LIST_REQUEST = "ORDER_ADMIN_LIST_REQUEST";
export const ORDER_ADMIN_LIST_SUCCESS = "ORDER_ADMIN_LIST_SUCCESS";
export const ORDER_ADMIN_LIST_FAIL = "ORDER_ADMIN_LIST_FAIL";
export const ORDER_ADMIN_LIST_RESET = "ORDER_ADMIN_LIST_RESET";

export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL";
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET";
